
import React from "react";
import ProjectTemplate from "../components/ProjectTemplate";

const DashPage = () => {
  const media = 
  [
    '/images/dashdashdash_2.webp', 
    '/images/dashdashdash.webp', 
  ];

  return (
    <div className="----page">
      <ProjectTemplate
        title="---"
        year="2021"
        sections={[
          {
            type: "description",
            text: '– – – is a 12 minute audiovisual composition consisting of three vertical projections, placed side by side with a small space in between them. At the core of this work is a programme which simulates the interference patterns of waves. The simulation manifests itself in both sound and image: the simulation is represented in two different media. The simulation runs in real-time and can be ‘played’ using a midi-controller, relating to an instrumental practise and allowing one interact with the interference patterns. The two representations in sound and image of the interference patterns are composed over the three projectors in time, where the two media are not always synced, but rather composed seperately and could be seen as two layers which interact with each other. The three vertical projections often show the same process but at varying speeds and camera angles.',
          },
          {
            type: "video",
            links: [
                
              "https://www.youtube.com/embed/olE_4pwO0B4?si=WDmXEcSBH3_YcFUn?controls=1&modestbranding=1&showinfo=0",
            ],
          }, 
          {
            type: "image",
            links: [
              {
                src: media[0]
              }
            ],
            isLink: false,
          },
          {
            type: "image",
            links: [
              {
                src: media[1]
              }
            ],
            isLink: false,
          },
        ]}
      />
    </div>
  );
};

export default DashPage;
